import React, { useMemo, useState } from "react";
import "./styles.less";

import { useTranslation } from "react-i18next";

export const FinanceChart = () => {
  const { t } = useTranslation();

  return (
    <div style={{ background: "#242933" }}>
      <section className="finance-chart basic-column">
        <h1 className="finance-title basic-title">
          {t("finance.chart.title")}
        </h1>
        <div className="finance-frame">
          <img
            src={t("finance.chart.img")}
            // src="https://files.authing.co/authing-website/finance-frame-zh.png"
            alt="authing"
          />
        </div>
      </section>
    </div>
  );
};
